var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRifArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 24,
    viewBox: "0 0 91 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.643 12.9819V12.36C51.8013 11.5313 53.1282 9.77089 53.1282 6.87084V6.45587C53.1282 2.58913 50.0903 0 45.1505 0L33.4224 0.0187025L33.4062 23.9264H38.8664V15.0532H46.4601C47.2815 15.0532 47.9468 15.6821 47.9468 16.4559V23.9264H53.3252V16.2618C53.3252 14.3285 51.582 13.0847 49.643 12.9819ZM47.0882 7.8457C47.0882 9.33022 46.0487 10.3098 44.2795 10.3098H38.8491V5.11631H44.2795C46.0785 5.11631 47.0882 6.09702 47.0882 7.58036V7.8457Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2637 0.0012207V23.9264H19.811V11.4308H15.321C14.7969 11.4308 14.2914 11.6155 13.9024 11.9463C13.6806 12.1356 13.5071 12.3648 13.3882 12.6172C13.2692 12.8697 13.2061 13.1456 13.2061 13.4273V16.3122C13.2061 17.086 12.5395 17.7148 11.7193 17.7148H8.0891C7.26766 17.7148 6.60233 17.086 6.60233 16.3122V12.8335C6.60233 12.0585 7.26766 11.4308 8.0891 11.4308H11.3526C11.7899 11.4308 12.2112 11.2847 12.5457 11.0205C12.7551 10.8545 12.9199 10.6488 13.0326 10.4197C13.1453 10.1918 13.2048 9.94044 13.2048 9.68328V5.14558H0.00976562V0.0012207H25.2637Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60372 20.831V20.8847C6.60372 22.6054 5.12439 23.9999 3.30186 23.9999C1.47934 23.9999 0 22.6054 0 20.8847V20.831C0 19.1103 1.4781 17.7158 3.30186 17.7158C4.21251 17.7158 5.0389 18.0642 5.63608 18.6276C6.23451 19.1922 6.60372 19.9706 6.60372 20.831Z",
    fill: "#121212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5907 5.1467V9.82116H89.2V14.547H80.0366C79.2374 14.547 78.5907 15.1572 78.5907 15.9112V23.9264H73.1367V0H74.5826L91.0002 0.00116891V5.1467H78.5907Z",
    fill: "#121212"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.736 4.51081V19.5476H69.0156V24H56.917V19.5476H60.1966V4.51081H56.917V0H69.0156V4.51081H65.736Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRifArrow);
export default __webpack_public_path__ + "static/media/rif-arrow.06be608d92eb23cf036610818ba3d80c.svg";
export { ForwardRef as ReactComponent };